import { render, staticRenderFns } from "./Discount.vue?vue&type=template&id=4732eefe"
import script from "./Discount.vue?vue&type=script&lang=js"
export * from "./Discount.vue?vue&type=script&lang=js"
import style0 from "./Discount.vue?vue&type=style&index=0&id=4732eefe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports